import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { HtmlParseService } from '@commons/html-parser/html-parse.service';
import { secureExternalLinks } from '@core/utils/utils';
import { Company } from '@models/company/company';
import { CustomTab } from '@models/company/custom-tab';
import { OpsEvent } from '@models/ops-event/ops-event';
import { Profile } from '@models/profile/profile';
import { Store } from '@ngxs/store';
import { CustomFormsState } from '@store/company/custom-forms/custom-forms.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'company-custom',
  templateUrl: './custom.component.html',
  styleUrls: ['./custom.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomComponent implements OnInit {
  @Input() fragment: string;
  @Input() company: Company;
  @Input() profile: Profile;

  customTab: CustomTab;
  tabContent: SafeHtml;
  tabContentAfterForm: string = null;
  hasFormVal = false;
  secureExternalLinks = secureExternalLinks;

  event$: Observable<OpsEvent>;

  constructor(private readonly htmlParser: HtmlParseService, private readonly store: Store) {}

  ngOnInit(): void {
    this.customTab = this.company.customTabs.find((customTab) => customTab.id === this.fragment);
    this.hasFormVal = this.hasForm(this.customTab.description);

    if (this.hasFormVal) {
      this.event$ = this.store.select(CustomFormsState.event(this.company.id, this.customTab.id, this.customTab.slug));

      const contents = this.customTab.description.split('%form%');
      this.tabContent = this.htmlParser.parse(contents[0]);
      this.tabContentAfterForm = this.htmlParser.parse(contents[1]);
    } else {
      this.tabContent = this.htmlParser.parse(this.customTab.description);
    }
  }

  private hasForm(content: string): boolean {
    return /%form%/gim.test(content);
  }
}
